// This file is auto-generated by @hey-api/openapi-ts
import { createClient, createConfig } from './client';
export const client = createClient(createConfig());
